import { __assign, __extends, __spreadArray } from "tslib";
import React, { Component } from 'react';
import { PnmacCard, PnmacCheckBox, PnmacPaper, PnmacParagraph, PnmacRadioButton, PnmacRadioButtonGroup, PnmacRow, PnmacRowHeader, PnmacSpecialRowHeader, PnmacSectionListView, PnmacSelect, PnmacSubheading, PnmacTable, PnmacTermsModal, PnmacTextInput, PnmacUIButton, PnmacMediaQuery, PnmacMeta, PnmacLinearProgress, PnmacText } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import styles from '../../styles/styles.js';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { isEmptyOrSpaces, checkForAllNumbers, encryptBankAccountNumber } from '../../utils.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { ActivityIndicator, Platform, Text, View } from 'react-native';
import { textStyle } from "../../v2/theme";
import BannerView from "../../v2/BannerView";
export var E_DIS = "E_DIS";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2)
      }
    }
  };
});
function LinearBuffer() {
  var classes = useStyles();
  var _a = React.useState(0),
    completed = _a[0],
    setCompleted = _a[1];
  var _b = React.useState(10),
    buffer = _b[0],
    setBuffer = _b[1];
  var progress = React.useRef(function () {});
  React.useEffect(function () {
    progress.current = function () {
      if (completed > 100) {
        setCompleted(0);
        setBuffer(10);
      } else {
        var diff = Math.random() * 10;
        var diff2 = Math.random() * 10;
        setCompleted(completed + diff);
        setBuffer(completed + diff + diff2);
      }
    };
  });
  React.useEffect(function () {
    function tick() {
      progress.current();
    }
    var timer = setInterval(tick, 500);
    return function () {
      clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(PnmacLinearProgress, {
    variant: "buffer",
    value: completed,
    valueBuffer: buffer
  }));
}
var PnmacToolTip = function (_a) {
  var title = _a.title,
    children = _a.children;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title
  }, children);
};
var AddBanks = /** @class */function (_super) {
  __extends(AddBanks, _super);
  function AddBanks(props) {
    var _this = _super.call(this, props) || this;
    _this.status = function (check) {
      return check.isEDisbursementAccount ? "checked" : "unchecked";
    };
    _this.addBankAccount = function () {
      var layout = _this.props.layout;
      var _a = _this.state,
        banks = _a.banks,
        newAccountNumber = _a.newAccountNumber,
        newAccountRoutingNumber = _a.newAccountRoutingNumber,
        newBankAccountType = _a.newBankAccountType,
        accountFirstName = _a.accountFirstName,
        accountMiddleName = _a.accountMiddleName,
        accountLastName = _a.accountLastName,
        borrowerId = _a.borrowerId,
        last4ofSSN = _a.last4ofSSN,
        accountName = _a.accountName,
        selectedBorrower = _a.selectedBorrower;
      if (last4ofSSN && borrowerId) {
        var b = banks || [];
        var newBank = {
          accountNumber: newAccountNumber,
          unmaskedAccountNumber: newAccountNumber,
          confirmAccountNumber: newAccountNumber,
          routingTransitNumber: newAccountRoutingNumber,
          bankAccountType: newBankAccountType,
          accountFirstName: accountFirstName,
          accountMiddleName: accountMiddleName,
          accountLastName: accountLastName,
          isEDisbursementAccount: true,
          borrowerid: borrowerId,
          loanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber,
          last4ofSSN: last4ofSSN,
          accountName: accountName,
          pending: true
        };
        b.push(newBank);
        fetch("".concat(layout.pennyHomeUrl, "api/payment/add_bank_account"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(layout.token)
          },
          body: JSON.stringify(__assign(__assign({}, newBank), {
            unmaskedAccountNumber: undefined,
            accountNumber: encryptBankAccountNumber(newAccountNumber),
            unmaskedAccountNumberEncode: encryptBankAccountNumber(newAccountNumber),
            confirmAccountNumber: encryptBankAccountNumber(newAccountNumber)
          }))
        });
        _this.setState({
          banks: b,
          cancelBankLoading: false,
          selectedBank: null,
          confirmSignUp: false,
          termsAndConditions: false,
          accountFirstName: '',
          accountMiddleName: '',
          selectedBorrower: 0,
          accountLastName: '',
          newAccountRoutingNumber: '',
          newAccountNumber: '',
          newAccountNumberRepeat: '',
          newBankAccountType: '',
          dropDownSelected: false,
          pending: true
        });
        _this.props.dispatch({
          type: E_DIS,
          banksToAdd: b
        });
      }
      setTimeout(function () {
        return _this.setState({
          pending: false
        });
      }, 40000);
      var pollBankList = setInterval(function () {
        return _this.props.refreshSingleLoanData(layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber);
      }, 20000);
      setTimeout(function () {
        return clearInterval(pollBankList);
      }, 60000);
    };
    _this.updateBankAccount = function () {
      var layout = _this.props.layout;
      var banks = _this.state.banks;
      _this.setState({
        pending: true
      });
      var newBank = banks.find(function (b) {
        return b.bankAccountId === _this.state.selectedBank;
      });
      fetch("".concat(layout.pennyHomeUrl, "api/payment/update_bank_account"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(__assign(__assign({}, newBank), {
          unmaskedAccountNumber: undefined,
          isEDisbursementAccount: true,
          loanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber,
          unmaskedAccountNumberEncode: encryptBankAccountNumber(newBank.unmaskedAccountNumber)
        }))
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data) {
          var newBanks = banks.map(function (bank) {
            if ((bank === null || bank === void 0 ? void 0 : bank.bankAccountId) === data.bankAccountId) return data;else return bank;
          });
          _this.props.dispatch({
            type: E_DIS,
            banksToAdd: newBanks
          });
          setInterval(function () {
            return _this.setState({
              pending: false
            });
          }, 30000);
        }
      });
    };
    _this.cancelBankAccount = function (bank) {
      var layout = _this.props.layout;
      var banks = _this.state.banks;
      _this.setState({
        pending: true
      });
      fetch("".concat(layout.pennyHomeUrl, "api/payment/cancel_bank_account"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(__assign(__assign({}, bank), {
          isEDisbursementAccount: false,
          unmaskedAccountNumber: undefined,
          loanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber,
          unmaskedAccountNumberEncode: encryptBankAccountNumber(bank.unmaskedAccountNumber)
        }))
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data) {
          var delBanks = banks.map(function (bank) {
            if (bank.bankAccountId === data.bankAccountId) return data;else return bank;
          });
          _this.props.dispatch({
            type: E_DIS,
            banksToAdd: delBanks
          });
          _this.setState({
            banks: __spreadArray([], delBanks, true),
            cancelBankLoading: false,
            selectedBank: null,
            confirmSignUp: false,
            termsAndConditions: false,
            selectedBorrower: 0,
            accountFirstName: '',
            accountMiddleName: '',
            accountLastName: '',
            newAccountRoutingNumber: '',
            newAccountNumber: '',
            newAccountNumberRepeat: '',
            newBankAccountType: '',
            dropDownSelected: false,
            alreadyEnrolled: false,
            pending: true
          });
        }
        setInterval(function () {
          return _this.setState({
            pending: false
          });
        }, 20000);
        var pollBankList = setInterval(function () {
          return _this.props.refreshSingleLoanData(layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber);
        }, 20000);
        setTimeout(function () {
          return clearInterval(pollBankList);
        }, 60000);
      }).catch(function () {
        _this.setState({
          pending: false
        });
      });
    };
    _this.checkEnrolledFlag = function () {
      return _this.state.banks.some(function (bank) {
        return bank.isEDisbursementAccount;
      }) ? _this.setState({
        alreadyEnrolled: true
      }) : _this.setState({
        alreadyEnrolled: false
      });
    };
    _this.getAccountAndRouteNumber = function (bank) {
      var _a;
      var translations = _this.props.translations;
      var accountNumber = (_a = bank.accountNumber) === null || _a === void 0 ? void 0 : _a.replace(/\b[\dX][-. \dX]+(\d{4})\b/g, function (match, capture) {
        return Array(match.length - 4).join("*") + capture;
      });
      return translations.eDis_AccountAndRouteNumber.replace('{0}', accountNumber).replace('{1}', bank.routingTransitNumber);
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.state = {
      termsAndConditions: false,
      openedTerms: false,
      modalOpenTerms: false,
      modalData: {
        cancel: null,
        accept: null,
        header: null,
        node: "",
        link: null,
        content: null,
        modelId: null,
        title: null
      },
      openedSignUp: false,
      signUpOpenTerms: false,
      confirmSignUp: false,
      cancelTerms: false,
      borrowers: null,
      bankPreference: '',
      selectedBorrower: null,
      initialLoading: true,
      yesname: null,
      banks: [],
      newAccountNumber: '',
      newAccountRoutingNumber: '',
      newAccountNumberRepeat: '',
      newBankAccountType: null,
      accountFirstName: '',
      accountMiddleName: '',
      accountLastName: '',
      borrowerId: 0,
      selectedBank: null,
      firstNameError: false,
      lastNameError: false,
      nameOnBankAccountLengthError: false,
      newAccountNumberError: false,
      newAccountNumberRepeatError: false,
      newAccountRoutingNumberError: false,
      alreadyEnrolled: false,
      dropDownSelected: false,
      cancelBankLoading: false,
      addedBankOpen: false,
      pending: false,
      yesNameError: false,
      last4ofSSN: null,
      accountName: null,
      timer: {
        count: 0,
        delay: 1000
      }
    };
    return _this;
  }
  AddBanks.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (props.layout.banksToAdd.length > 0 && state.banks !== props.layout.banksToAdd || props.layout.banksToAdd.length == 0) {
      var auto = props.layout.banksToAdd.find(function (e) {
        return e.isEDisbursementAccount;
      });
      if (auto) {
        return __assign(__assign({}, state), {
          banks: props.layout.banksToAdd,
          borrowers: (_c = (_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.currentLoan) === null || _b === void 0 ? void 0 : _b.borrowerSummary) === null || _c === void 0 ? void 0 : _c.filter(function (borrower) {
            var _a;
            return borrower.loanId === ((_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanNumber) && borrower.customerDeceasedFlag === false;
          }),
          selectedBank: auto.bankAccountId
        });
      }
      return __assign(__assign({}, state), {
        banks: props.layout.banksToAdd,
        borrowers: (_f = (_e = (_d = props.layout) === null || _d === void 0 ? void 0 : _d.currentLoan) === null || _e === void 0 ? void 0 : _e.borrowerSummary) === null || _f === void 0 ? void 0 : _f.filter(function (borrower) {
          var _a;
          return borrower.loanId === ((_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanNumber) && borrower.customerDeceasedFlag === false;
        })
      });
    } else if (((_j = (_h = (_g = props.layout) === null || _g === void 0 ? void 0 : _g.currentLoan) === null || _h === void 0 ? void 0 : _h.borrowerSummary) === null || _j === void 0 ? void 0 : _j.length) > 0) {
      return __assign(__assign({}, state), {
        borrowers: (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.currentLoan) === null || _l === void 0 ? void 0 : _l.borrowerSummary) === null || _m === void 0 ? void 0 : _m.filter(function (borrower) {
          var _a;
          return borrower.loanId === ((_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanNumber) && borrower.customerDeceasedFlag === false;
        })
      });
    } else return null;
  };
  AddBanks.prototype.componentDidMount = function () {
    //let { tableData } = this.props.tableData;
    //this.updateBankAccount()
  };
  AddBanks.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    var _b = this.state,
      borrowers = _b.borrowers,
      banks = _b.banks,
      alreadyEnrolled = _b.alreadyEnrolled,
      selectedBorrower = _b.selectedBorrower,
      pending = _b.pending;
    var tableHead = [translations.eDis_EligibleBankAccounts, 'Account Type', 'Enroll'];
    var allInputsFilled = this.state.yesname !== null && this.state.accountLastName != '' && this.state.accountFirstName != '' && this.state.newAccountNumber !== '' && !this.state.newAccountNumberError && this.state.newAccountNumberRepeat !== '' && !this.state.newAccountNumberRepeatError && this.state.newAccountRoutingNumber !== '' && this.state.newBankAccountType !== null && !this.state.newAccountRoutingNumberError && !this.state.nameOnBankAccountLengthError;
    var tableData = banks.map(function (bank) {
      return [/*#__PURE__*/React.createElement(PnmacParagraph, {
        style: __assign({
          padding: 5
        }, textStyle.defaultTextDescription)
      }, _this.getAccountAndRouteNumber(bank)), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: __assign({
          padding: 5
        }, textStyle.defaultTextDescription)
      }, bank.bankAccountType === 201286 ? "Checking" : bank.bankAccountType === 201287 ? "Savings" : bank.bankAccountType === 201288 ? translations.eDis_Debit_Card : translations.eDis_Unknown), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        disabled: _this.state.selectedBorrower > 0,
        status: _this.state.selectedBank === bank.bankAccountId || bank.isEDisbursementAccount ? "checked" : "unchecked",
        onPress: function () {
          if (banks.some(function (bank) {
            return bank.isEDisbursementAccount;
          })) {
            _this.setState({
              alreadyEnrolled: true
            });
          } else {
            _this.setState({
              selectedBank: bank.bankAccountId
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Radio, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "event when customers selecting from a list of eligible banks", 0);
          }
          if (_this.state.selectedBank === bank.bankAccountId) {
            _this.setState({
              selectedBank: null
            });
          }
        }
      })), /*#__PURE__*/React.createElement(PnmacTermsModal, {
        isSkipStrict: true,
        cancelTerms: function () {
          return null;
        },
        open: _this.state.cancelTerms,
        ACE: true,
        callbackOnAccept: function (data) {
          var _a;
          var bankToCancel = banks.find(function (b) {
            return b.bankAccountId === _this.state.selectedBank;
          });
          _this.setState((_a = {}, _a[data.node] = true, _a.cancelBankLoading = true, _a.alreadyEnrolled = false, _a.cancelTerms = false, _a));
          _this.cancelBankAccount(bankToCancel);
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on the Yes cancel my bank account button", 0);
        },
        enject: true,
        disableClickOut: true,
        handleClose: function () {
          _this.setState({
            cancelTerms: false
          });
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on the go back on the cancel pop up", 0);
        },
        data: __assign(__assign({}, _this.state.modalData), {
          closeIcon: " "
        })
      }), bank.isEDisbursementAccount && /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: "outlined",
        // loading={this.state.cancelBankLoading}
        onClick: function () {
          if (!_this.state.cancelTerms) {
            _this.setState({
              selectedBank: bank.bankAccountId,
              cancelTerms: true,
              tableData: true,
              selectedBorrower: 0,
              //alreadyEnrolled: false,
              modalData: __assign(__assign({}, _this.state.modalData), {
                cancel: "".concat(translations.goBack),
                node: "cancelBank",
                accept: "".concat(translations.yesCancelBank),
                header: "Cancel bank account",
                content: translations.confirmPopUp,
                title: "Cancellation Terms and Conditions"
              })
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click the cancel link by the enrolled bank", 0);
          } else {
            _this.setState({
              cancelTerms: !_this.state.cancelTerms
            });
          }
        }
      }, "Cancel")))];
    });
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, pending && /*#__PURE__*/React.createElement(View, {
        style: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: 'absolute',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 999,
          backgroundColor: 'rgba(0,0,0,0.1)',
          borderRadius: 10
        }
      }, /*#__PURE__*/React.createElement(ActivityIndicator, {
        style: {
          marginHorizontal: 10
        }
      }), /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextTitle
      }, translations === null || translations === void 0 ? void 0 : translations.PendingLoaderText)), /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "eDisbursement"
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          backgroundColor: "#FFF",
          marginTop: 20,
          marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          elevation: 1,
          width: "100%",
          cursor: "auto"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: matches.small ? "flex" : "initial",
          flexDirection: matches.small ? "column" : "flex-start",
          alignItems: "center",
          paddingBottom: 30,
          borderBottom: "1px solid #e9e9e9",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 20,
          paddingLeft: 40,
          paddingRight: 40
        }
      }, /*#__PURE__*/React.createElement(PnmacSubheading, {
        style: __assign({
          alignSelf: "flex-start"
        }, textStyle.defaultTextTitle)
      }, translations.getStarted2)), /*#__PURE__*/React.createElement(PnmacCard, {
        style: {
          width: matches.small ? "97%" : "93%",
          marginLeft: matches.small ? 0 : 40
        }
      }, /*#__PURE__*/React.createElement(PnmacTable, {
        style: {
          width: "100%"
        },
        borderstyle: {
          borderColor: 'transparent'
        }
      }, /*#__PURE__*/React.createElement(PnmacRow, {
        flexArr: [2, 1, 1],
        data: tableHead,
        style: __assign(__assign({}, styles.eDisbursement.head), {
          height: "auto",
          paddingLeft: 5
        }),
        textStyle: [textStyle.defaultTextTitle, {
          margin: 10
        }]
      }), tableData === null || tableData === void 0 ? void 0 : tableData.map(function (rowData, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "rowKey".concat(index)
        }, /*#__PURE__*/React.createElement(PnmacRow, {
          key: index,
          flexArr: [2, 1, 1],
          data: rowData,
          style: {
            borderBottomWidth: 0,
            paddingLeft: 10,
            backgroundColor: index % 2 === 0 ? '#fff' : '#efefef',
            borderBottomLeftRadius: index === tableData.length - 1 ? 10 : 0,
            borderBottomRightRadius: index === tableData.length - 1 ? 10 : 0
          },
          textStyle: __assign(__assign({}, textStyle.defaultTextDescription), {
            fontSize: matches.small ? 12 : 16
          })
        }));
      }))), alreadyEnrolled && /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          textAlign: "center",
          color: "#b33734"
        })
      }, translations === null || translations === void 0 ? void 0 : translations.CancelEnrolledBankAccount)), /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        ref: _this.expRef,
        data: [{
          title: translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount,
          data: [{
            header: translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount
          }]
        }],
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var item = _a.item,
            index = _a.index;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            if (item.header == (translations === null || translations === void 0 ? void 0 : translations.NachaAddNewBankAccount)) {
              return /*#__PURE__*/React.createElement("div", {
                style: __assign({}, styles.eDisbursement.section)
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  marginLeft: 10,
                  marginTop: 10
                }
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: textStyle.defaultTextTitle
              }, translations.bankBelongBorrower)), /*#__PURE__*/React.createElement("div", {
                style: {
                  alignSelf: "flex-start",
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 20,
                  paddingLeft: 10,
                  width: matches.small ? "98%" : "50%"
                }
              }, /*#__PURE__*/React.createElement(PnmacParagraph, {
                style: __assign(__assign({}, textStyle.formBody), {
                  marginBottom: 10
                })
              }, translations === null || translations === void 0 ? void 0 : translations.SelectNameOnBankAccount), /*#__PURE__*/React.createElement("div", {
                onClick: function () {
                  _this.setState({
                    selectedBank: null
                  });
                  _this.checkEnrolledFlag();
                  _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Add a Bank section", 0);
                }
              }, /*#__PURE__*/React.createElement(PnmacSelect, {
                accessibilityLabel: "Select Name",
                placeholder: {
                  label: 'Select a name...',
                  value: 0
                },
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                onValueChange: function (value) {
                  if (!isNaN(value) && parseInt(value) > 1) {
                    var bor = borrowers.find(function (s) {
                      return s.borrowerId == parseInt(value);
                    });
                    if (bor) {
                      _this.setState({
                        selectedBank: null,
                        selectedBorrower: value,
                        accountFirstName: bor === null || bor === void 0 ? void 0 : bor.borrowerFirstName,
                        accountMiddleName: bor === null || bor === void 0 ? void 0 : bor.borrowerMiddleName,
                        accountLastName: bor === null || bor === void 0 ? void 0 : bor.borrowerLastName,
                        borrowerId: bor === null || bor === void 0 ? void 0 : bor.borrowerId,
                        last4ofSSN: bor.borrowerLastFourSsn,
                        accountName: "".concat(bor === null || bor === void 0 ? void 0 : bor.borrowerFirstName, " ").concat(bor === null || bor === void 0 ? void 0 : bor.borrowerMiddleName, " ").concat(bor === null || bor === void 0 ? void 0 : bor.borrowerLastName)
                      });
                      _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.SelectOne, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting a name from drop down", 0);
                    }
                  }
                },
                value: parseInt(_this.state.selectedBorrower),
                items: (borrowers === null || borrowers === void 0 ? void 0 : borrowers.map(function (borrower) {
                  return {
                    label: "".concat(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerFirstName, " ").concat(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerMiddleName, " ").concat(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerLastName),
                    value: parseInt(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerId)
                  };
                })) || [{
                  label: "default",
                  value: "default"
                }]
              }))), _this.state.selectedBorrower > 0 ? /*#__PURE__*/React.createElement("div", {
                style: {
                  alignSelf: "flex-start",
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 20,
                  paddingLeft: 10,
                  width: matches.small ? "98%" : "50%"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  width: matches.small ? "90%" : "100%",
                  marginBottom: 10
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  width: "85%"
                }
              }, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations === null || translations === void 0 ? void 0 : translations.nameSelectedMatch
                }
              })), /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
                onValueChange: function (val) {
                  var bor = borrowers.find(function (s) {
                    return s.borrowerId == _this.state.selectedBorrower;
                  });
                  if (val == "yes") {
                    _this.setState({
                      yesname: val,
                      accountFirstName: bor.borrowerFirstName,
                      accountMiddleName: bor.borrowerMiddleName,
                      accountLastName: bor.borrowerLastName,
                      borrowerId: bor === null || bor === void 0 ? void 0 : bor.borrowerId,
                      last4ofSSN: bor.borrowerLastFourSsn,
                      accountName: "".concat(bor === null || bor === void 0 ? void 0 : bor.borrowerFirstName, " ").concat(bor === null || bor === void 0 ? void 0 : bor.borrowerMiddleName, " ").concat(bor === null || bor === void 0 ? void 0 : bor.borrowerLastName)
                    });
                    _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Radio, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting yes button that their name matches", 0);
                  } else {
                    _this.setState({
                      yesname: val,
                      accountFirstName: "",
                      accountMiddleName: "",
                      accountLastName: ""
                    });
                    _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Radio, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting no button that their name matches", 0);
                  }
                },
                value: _this.state.yesname
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  width: "18%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: __assign({
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }, textStyle.defaultTextDescription)
              }, /*#__PURE__*/React.createElement("div", null, translations.yes), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }),
                value: "yes",
                status: _this.state.yesname ? "checked" : "unchecked"
              })), /*#__PURE__*/React.createElement("div", {
                style: __assign({
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }, textStyle.defaultTextDescription)
              }, /*#__PURE__*/React.createElement("div", null, translations.no), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }),
                value: "no"
              }))))), _this.state.yesNameError ? /*#__PURE__*/React.createElement("div", {
                style: __assign({
                  color: "#b33734"
                }, textStyle.defaultTextDescription)
              }, translations.NachaBorrowerNameValidationMessage) : null)) : null, _this.state.yesname === 'no' ? /*#__PURE__*/React.createElement("div", {
                style: {
                  alignSelf: "flex-start",
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: 10
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 20
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  width: "98%",
                  marginBottom: matches.small ? 20 : 0
                }
              }, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations === null || translations === void 0 ? void 0 : translations.enterName
                }
              })), _this.state.nameOnBankAccountLengthError ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
                style: {
                  color: 'red',
                  fontSize: 12,
                  height: 15
                }
              }, translations === null || translations === void 0 ? void 0 : translations.BankAccountLengthError), /*#__PURE__*/React.createElement("br", null)) : null, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: matches.small ? "column" : "row",
                  justifyContent: "space-between",
                  width: matches.small ? "98%" : "70%"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column"
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: [textStyle.defaultTextTitle, {
                  marginVertical: 10
                }]
              }, translations === null || translations === void 0 ? void 0 : translations.FirstName), /*#__PURE__*/React.createElement(PnmacTextInput, {
                textAlign: 'left',
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                mode: "outlined",
                label: _this.state.firstNameError ? translations === null || translations === void 0 ? void 0 : translations.EnterFirstName : translations === null || translations === void 0 ? void 0 : translations.FirstName,
                value: _this.state.accountFirstName,
                placeholder: translations === null || translations === void 0 ? void 0 : translations.FirstName,
                error: _this.state.firstNameError,
                onChangeText: function (data) {
                  _this.setState({
                    accountFirstName: data
                  });
                },
                onBlur: function () {
                  if (isEmptyOrSpaces(_this.state.accountFirstName)) {
                    _this.setState({
                      firstNameError: true
                    });
                  } else {
                    _this.setState({
                      firstNameError: false
                    });
                    _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Text, TrackerHitTypeLID_ENUM.Transaction, TrackerActionLID_ENUM.Select, "customers entering First Name", 0);
                  }
                  if (_this.state.accountFirstName.length + _this.state.accountMiddleName.length + _this.state.accountLastName.length > 50) {
                    _this.setState({
                      nameOnBankAccountLengthError: true
                    });
                  } else {
                    _this.setState({
                      nameOnBankAccountLengthError: false
                    });
                  }
                }
              })), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column"
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: [textStyle.defaultTextTitle, {
                  marginTop: 10,
                  marginBottom: 10
                }]
              }, translations === null || translations === void 0 ? void 0 : translations.MiddleInitial), /*#__PURE__*/React.createElement(PnmacTextInput, {
                textAlign: 'left',
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                mode: "outlined",
                label: translations === null || translations === void 0 ? void 0 : translations.MiddleInitial,
                value: _this.state.accountMiddleName,
                placeholder: translations === null || translations === void 0 ? void 0 : translations.MiddleInitial,
                error: "",
                onChangeText: function (data) {
                  if ((data === null || data === void 0 ? void 0 : data.length) <= 1) {
                    _this.setState({
                      accountMiddleName: data
                    });
                  }
                },
                onBlur: function () {
                  if (!isEmptyOrSpaces(_this.state.accountFirstName)) {
                    _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Text, TrackerHitTypeLID_ENUM.Transaction, TrackerActionLID_ENUM.Select, "customers entering Middle Name", 0);
                  }
                  if (_this.state.accountFirstName.length + _this.state.accountMiddleName.length + _this.state.accountLastName.length > 50) {
                    _this.setState({
                      nameOnBankAccountLengthError: true
                    });
                  } else {
                    _this.setState({
                      nameOnBankAccountLengthError: false
                    });
                  }
                }
              })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacText, {
                style: [textStyle.defaultTextTitle, {
                  marginTop: 10,
                  marginBottom: 10
                }]
              }, translations === null || translations === void 0 ? void 0 : translations.LastName), /*#__PURE__*/React.createElement(PnmacTextInput, {
                textAlign: 'left',
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                mode: "outlined",
                label: _this.state.lastNameError ? translations === null || translations === void 0 ? void 0 : translations.EnterLastName : translations === null || translations === void 0 ? void 0 : translations.LastName,
                value: _this.state.accountLastName,
                placeholder: translations === null || translations === void 0 ? void 0 : translations.LastName,
                error: _this.state.lastNameError,
                onChangeText: function (data) {
                  return _this.setState({
                    accountLastName: data
                  });
                },
                onBlur: function () {
                  if (isEmptyOrSpaces(_this.state.accountLastName)) {
                    _this.setState({
                      lastNameError: true
                    });
                  } else {
                    _this.setState({
                      lastNameError: false
                    });
                    _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Text, TrackerHitTypeLID_ENUM.Transaction, TrackerActionLID_ENUM.Select, "customers entering Last Name", 0);
                  }
                  if (_this.state.accountFirstName.length + _this.state.accountMiddleName.length + _this.state.accountLastName.length > 50) {
                    _this.setState({
                      nameOnBankAccountLengthError: true
                    });
                  } else {
                    _this.setState({
                      nameOnBankAccountLengthError: false
                    });
                  }
                }
              }))))) : null, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: matches.small ? "column" : "row",
                  alignSelf: "flex-start",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingLeft: 10,
                  paddingBottom: 10
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  width: matches.small ? "98%" : "65%",
                  display: "flex",
                  flexDirection: "column",
                  alignSelf: "flex-start",
                  justifyContent: "space-between",
                  paddingLeft: 10,
                  marginRight: 30
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: __assign(__assign({}, styles.eDisbursement.inputContainer), {
                  marginTop: 40
                })
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: __assign(__assign({}, textStyle.defaultTextTitle), {
                  fontSize: matches.small ? 14 : 16,
                  paddingRight: 5
                })
              }, translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber), /*#__PURE__*/React.createElement(PnmacTextInput, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                mode: "outlined",
                style: {
                  width: "50%"
                },
                label: _this.state.newAccountRoutingNumberError ? translations === null || translations === void 0 ? void 0 : translations.RoutingNumberValidationMessage : translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber,
                textAlign: 'left',
                nativeID: "routingNumber1",
                value: _this.state.newAccountRoutingNumber,
                placeholder: translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber,
                maxLength: 9,
                error: _this.state.newAccountRoutingNumberError,
                onChangeText: function (data) {
                  if (checkForAllNumbers(data)) {
                    _this.setState({
                      newAccountRoutingNumber: data
                    });
                  }
                },
                onBlur: function () {
                  if (checkForAllNumbers(_this.state.newAccountRoutingNumber, 9)) {
                    // turn to POST
                    fetch("".concat(layout.pennyHomeUrl, "api/payment/ValidateRoutingNumber?routingnumber=").concat(_this.state.newAccountRoutingNumber), {
                      method: 'POST',
                      headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": "Bearer ".concat(layout.token)
                      }
                    }).then(function (res) {
                      return res.json();
                    }).then(function (isValidRoutingNumber) {
                      isValidRoutingNumber ? _this.setState({
                        newAccountRoutingNumberError: false
                      }) : _this.setState({
                        newAccountRoutingNumberError: true
                      });
                    });
                  } else {
                    _this.setState({
                      newAccountRoutingNumberError: true
                    });
                  }
                  if (!_this.state.yesname) {
                    _this.setState({
                      yesNameError: true
                    });
                  } else _this.setState({
                    yesNameError: false
                  });
                }
              })), /*#__PURE__*/React.createElement("div", {
                style: styles.eDisbursement.inputContainer
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: __assign(__assign({}, textStyle.defaultTextTitle), {
                  fontSize: matches.small ? 14 : 16,
                  paddingRight: 5
                })
              }, translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber), /*#__PURE__*/React.createElement(PnmacTextInput, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                mode: "outlined",
                style: {
                  width: "50%"
                },
                label: _this.state.newAccountNumberError ? translations === null || translations === void 0 ? void 0 : translations.BankAccountNumberValidationMessage : translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber,
                textAlign: 'left',
                nativeID: "accountNumber1",
                value: _this.state.newAccountNumber,
                placeholder: translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber,
                maxLength: 17,
                error: _this.state.newAccountNumberError,
                onChangeText: function (data) {
                  if (checkForAllNumbers(data)) {
                    _this.setState({
                      newAccountNumber: data
                    });
                  }
                },
                onBlur: function () {
                  if (!checkForAllNumbers(_this.state.newAccountNumber, _this.state.newAccountNumber.length >= 5)) {
                    if (_this.state.newAccountNumberRepeat !== '') {
                      _this.state.newAccountNumberRepeat === _this.state.newAccountNumber ? _this.setState({
                        newAccountNumberRepeatError: false
                      }) : _this.setState({
                        newAccountNumberRepeatError: true
                      });
                    }
                    _this.setState({
                      newAccountNumberError: false
                    });
                  } else {
                    _this.setState({
                      newAccountNumberError: true
                    });
                  }
                }
              })), /*#__PURE__*/React.createElement("div", {
                style: styles.eDisbursement.inputContainer
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: __assign(__assign({}, textStyle.defaultTextTitle), {
                  fontSize: matches.small ? 14 : 16,
                  paddingRight: 5
                })
              }, translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumber), /*#__PURE__*/React.createElement(PnmacTextInput, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                mode: "outlined",
                style: {
                  width: "50%"
                },
                label: _this.state.newAccountNumberRepeatError ? translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumberValidationMessage : translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumber,
                textAlign: 'left',
                nativeID: "accountNumberRepeat1",
                value: _this.state.newAccountNumberRepeat,
                placeholder: translations === null || translations === void 0 ? void 0 : translations.ConfirmAccountNumber,
                maxLength: 17,
                error: _this.state.newAccountNumberRepeatError,
                onChangeText: function (data) {
                  if (checkForAllNumbers(data)) {
                    _this.setState({
                      newAccountNumberRepeat: data
                    });
                  }
                },
                onBlur: function () {
                  _this.state.newAccountNumberRepeat === _this.state.newAccountNumber ? _this.setState({
                    newAccountNumberRepeatError: false
                  }) : _this.setState({
                    newAccountNumberRepeatError: true
                  });
                }
              })), /*#__PURE__*/React.createElement("div", {
                style: __assign(__assign({}, styles.eDisbursement.inputContainer), {
                  justifyContent: "flex-start"
                })
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: __assign(__assign({}, textStyle.defaultTextTitle), {
                  width: "50%",
                  fontSize: matches.small ? 14 : 16
                })
              }, translations === null || translations === void 0 ? void 0 : translations.BankAccountType), /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
                onValueChange: function (val) {
                  var msg = val === 201286 ? "Checking" : "Savings";
                  _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "customers selecting ".concat(msg), 0);
                  _this.setState({
                    newBankAccountType: val
                  });
                },
                value: _this.state.newBankAccountType
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  width: "50%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  fontSize: 12
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: textStyle.defaultTextDescription
              }, translations === null || translations === void 0 ? void 0 : translations.Checking), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                value: 201286
              })), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  fontSize: 12
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: textStyle.defaultTextDescription
              }, translations === null || translations === void 0 ? void 0 : translations.Savings), /*#__PURE__*/React.createElement(PnmacRadioButton, {
                disabled: banks.some(function (b) {
                  return b.isEDisbursementAccount === true;
                }) || _this.state.selectedBank !== null,
                value: 201287
              })))))), /*#__PURE__*/React.createElement("div", {
                style: {
                  alignSelf: "center"
                }
              }, /*#__PURE__*/React.createElement("img", {
                src: require("../../assets/check-fill-info.png"),
                alt: "blank check template",
                width: "280",
                height: "200"
              }))));
            }
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c;
          var title = _a.section.title;
          return /*#__PURE__*/React.createElement(PnmacSpecialRowHeader, {
            rowHeaderStyles: __assign(__assign({}, styles.selectionListView.rowHeaderStyles), {
              paddingLeft: 10,
              fontWeight: 400
            }),
            rowHeaderContainerStyles: {
              backgroundColor: "transparent",
              borderBottom: "1px solid #e9e9e9",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              marginTop: 0,
              marginBottom: 0
            },
            onClickExpand: function () {
              var _a;
              var c = (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
              setTimeout(function () {
                Platform.select({
                  android: function () {},
                  ios: function () {},
                  web: function () {
                    var bankRef1 = document.getElementById('accountNumber1');
                    var bankRef2 = document.getElementById('accountNumberRepeat1');
                    if (bankRef1) {
                      bankRef1.addEventListener("copy", function (evt) {
                        evt.preventDefault();
                      }, false);
                      bankRef1.addEventListener("paste", function (evt) {
                        evt.preventDefault();
                      }, false);
                      bankRef1.addEventListener("drag", function (evt) {
                        evt.preventDefault();
                      }, false);
                      bankRef1.addEventListener("drop", function (evt) {
                        evt.preventDefault();
                      }, false);
                    }
                    if (bankRef2) {
                      bankRef2.addEventListener("copy", function (evt) {
                        evt.preventDefault();
                      }, false);
                      bankRef2.addEventListener("paste", function (evt) {
                        evt.preventDefault();
                      }, false);
                      bankRef2.addEventListener("drag", function (evt) {
                        evt.preventDefault();
                      }, false);
                      bankRef2.addEventListener("drop", function (evt) {
                        evt.preventDefault();
                      }, false);
                    }
                  }
                })();
              }, 500);
            },
            item: /*#__PURE__*/React.createElement(PnmacToolTip, {
              title: "Expand " + title
            }, /*#__PURE__*/React.createElement("div", {
              style: __assign({
                alignSelf: "center"
              }, textStyle.formTitleSection)
            }, title)),
            isExpand: ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1
          });
        }
      })), /*#__PURE__*/React.createElement(PnmacTermsModal, {
        data: {
          closeIcon: " ",
          cancel: "".concat(translations.goBack),
          accept: "".concat(translations.eDis_AgreeAndContinue),
          header: "Terms and Conditions",
          node: "termsAndConditions",
          content: "<span data-focusable=\"true\" tabindex=\"0\">".concat(translations.termsConditions, "</span>"),
          title: "eDisbursement Terms and Conditions"
        },
        cancelTerms: function () {
          return null;
        },
        open: _this.state.modalOpenTerms || false,
        ACE: true,
        visibilitySpacer: true,
        callbackOnAccept: function (data) {
          var _a;
          return _this.setState((_a = {}, _a[data.node] = true, _a.modalOpenTerms = false, _a.openedTerms = true, _a));
        },
        enject: true,
        disableClickOut: true,
        handleClose: function () {
          return _this.setState({
            modalOpenTerms: false
          });
        },
        matches: matches
      }), /*#__PURE__*/React.createElement(PnmacTermsModal, {
        isSkipStrict: true,
        cancelTerms: function () {
          return null;
        },
        open: _this.state.signUpOpenTerms || false,
        ACE: true,
        callbackOnAccept: function (data) {
          var _a;
          if (_this.state.selectedBorrower > 0) {
            _this.setState({
              addedBankOpenTerms: true
            });
          } else {
            _this.updateBankAccount();
          }
          _this.setState((_a = {}, _a[data.node] = true, _a.signUpOpenTerms = false, _a.openedSignUp = false, _a));
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Yes sign up on the confirmation pop up", 0);
        },
        enject: true,
        disableClickOut: true,
        handleClose: function () {
          _this.setState({
            signUpOpenTerms: false
          });
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on the Go back on the confirmation pop up", 0);
        },
        data: __assign(__assign({}, _this.state.modalData), {
          closeIcon: " "
        }),
        matches: matches
      }), /*#__PURE__*/React.createElement(PnmacTermsModal, {
        isSkipStrict: true,
        cancelTerms: function () {
          return null;
        },
        open: _this.state.addedBankOpenTerms || false,
        ACE: true,
        callbackOnAccept: function (data) {
          var _a;
          _this.addBankAccount();
          _this.setState((_a = {}, _a[data.node] = true, _a.selectedBorrower = 0, _a.addedBankOpenTerms = false, _a));
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Accept on the second pop up", 0);
        },
        enject: true,
        disableClickOut: true,
        hideCancelButton: true,
        data: {
          closeIcon: " ",
          accept: "Accept",
          header: "Bank submitted for eDisbursement",
          node: "addedBank",
          content: "".concat(translations.twoThreeDays),
          title: "Bank submitted for eDisbursement"
        },
        matches: matches
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 20,
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          flexDirection: 'row',
          alignItems: "center",
          marginHorizontal: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          if (!_this.state.openedTerms) {
            _this.setState({
              modalOpenTerms: true
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.CheckBox, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "log of accepting for Terms and conditions", 0);
          } else {
            _this.setState({
              termsAndConditions: !_this.state.termsAndConditions
            });
          }
        }
      }, /*#__PURE__*/React.createElement(PnmacCheckBox, {
        status: _this.state.termsAndConditions ? 'checked' : 'unchecked'
      })), /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          _this.setState({
            modalOpenTerms: true
          });
        },
        style: {
          color: _this.state.termsAndConditions ? "black" : "#b33734"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: 'htmlToNative',
        dangerouslySetInnerHTML: {
          __html: translations === null || translations === void 0 ? void 0 : translations.agreeToC
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          flexDirection: matches.small ? 'column' : 'row'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, styles.accountSettings.buttonContainer), {
          backgroundColor: "transparent"
        })
      }, /*#__PURE__*/React.createElement(Link, {
        push: "true",
        to: "/Account/AccountSettings",
        style: {
          width: matches.small ? "auto" : "40%",
          textDecoration: "none"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'outlined',
        onPress: function () {
          _this.setState({
            cancelBankLoading: false,
            selectedBank: null,
            confirmSignUp: false,
            termsAndConditions: false,
            selectedBorrower: 0,
            accountFirstName: '',
            accountMiddleName: '',
            accountLastName: '',
            newAccountRoutingNumber: '',
            newAccountNumber: '',
            newAccountNumberRepeat: '',
            newBankAccountType: '',
            dropDownSelected: false
          });
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Cancel at the bottom of the page", 0);
        }
      }, translations.cancel))), /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, styles.accountSettings.buttonContainer), {
          marginBottom: 20,
          marginTop: matches.small ? 10 : 0
        })
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        disabled: _this.state.banks.some(function (bank) {
          return bank.isEDisbursementAccount;
        }) ? true : _this.state.termsAndConditions ? _this.state.selectedBank !== null ? false : !allInputsFilled : true,
        loading: _this.state.loading,
        onPress: function () {
          if (!_this.state.openedSignUp && !(_this.state.termsAndConditions ? _this.state.selectedBank !== null ? false : !allInputsFilled : true)) {
            _this.setState({
              termsAndConditions: false,
              signUpOpenTerms: true,
              modalData: __assign(__assign({}, _this.state.modalData), {
                cancel: "".concat(translations.goBack),
                node: "confirmationPopUp",
                accept: "".concat(translations.yesSignUp),
                header: "Confirm Sign Up",
                content: "".concat(translations.addBankPopUp),
                title: "Confirm Bank Sign Up"
              })
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on Continue at the bottom of the page", 0);
          } else {
            _this.setState({
              confirmSignUp: false
            });
          }
        }
      }, "Continue"))))));
    });
  };
  return AddBanks;
}(React.Component);
var Edisbursments = /** @class */function (_super) {
  __extends(Edisbursments, _super);
  function Edisbursments(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      pushHederRef: /*#__PURE__*/React.createRef(),
      called: false
    };
    return _this;
  }
  Edisbursments.getDerivedStateFromProps = function (props, state) {
    var _a, _b;
    var translations = props.translations;
    if (((_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.banksToAdd) === null || _b === void 0 ? void 0 : _b.length) === 0) {
      if (state.pushHederRef.current && !state.called) {
        state.pushHederRef.current.expandItemOpen(translations.howItWorksSubheader);
        return __assign(__assign({}, state), {
          called: true
        });
      }
      return __assign({}, state);
    } else {
      if (state.pushHederRef.current && !state.called) {
        state.pushHederRef.current.expandItemOpen(translations.getStarted);
        return __assign(__assign({}, state), {
          called: true
        });
      }
      return __assign({}, state);
    }
  };
  Edisbursments.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    var isEligible = layout.isEligible;
    var DATAEXPANDABLE = [{
      title: "".concat(translations.howItWorksSubheader),
      data: [{
        header: "".concat(translations.howItWorksSubheader)
      }]
    }, {
      title: "".concat(translations.getStarted),
      data: [{
        header: "".concat(translations.getStarted)
      }]
    }];
    return !layout.selectedLoanNumber ? /*#__PURE__*/React.createElement(LinearBuffer, null) : isEligible ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 40,
        backgroundColor: "#FFF",
        borderRadius: 10,
        boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px"
      }
    }, /*#__PURE__*/React.createElement(PnmacRowHeader, {
      rowHeaderStyles: styles.accountSettings.header,
      rowHeaderContainerStyles: {
        boxShadow: "none",
        borderBottom: "1px solid #e9e9e9",
        borderRadius: 0,
        marginBottom: 0
      },
      item: translations.eDisbursementsTile
    }), /*#__PURE__*/React.createElement(PnmacSectionListView, {
      openDefaults: ["".concat(translations.getStarted), "".concat(translations.howItWorksSubheader)],
      ref: this.state.pushHederRef,
      data: DATAEXPANDABLE,
      collapsableSections: true,
      renderItem: function (_a, collapsed) {
        var item = _a.item,
          index = _a.index;
        if (collapsed.some(function (s) {
          return s == item.header;
        })) {
          if (item.header == "".concat(translations.howItWorksSubheader)) {
            return /*#__PURE__*/React.createElement("div", {
              style: __assign({}, styles.eDisbursement.section)
            }, /*#__PURE__*/React.createElement(PnmacParagraph, {
              style: textStyle.formBody
            }, /*#__PURE__*/React.createElement("span", {
              className: 'htmlToNative',
              dangerouslySetInnerHTML: {
                __html: translations === null || translations === void 0 ? void 0 : translations.howItWorks
              }
            })));
            //this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on How it works?", 0)
          } else if (item.header == "".concat(translations.getStarted)) {
            return /*#__PURE__*/React.createElement(AddBanks, __assign({}, _this.props));
          }
        } else {
          return /*#__PURE__*/React.createElement("div", null);
        }
      },
      renderSectionHeader: function (_a) {
        var _b, _c, _d, _e;
        var title = _a.section.title;
        var last = title === "".concat(translations.getStarted);
        var open = ((_c = (_b = _this.state.pushHederRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
        return /*#__PURE__*/React.createElement(PnmacRowHeader, {
          rowHeaderStyles: __assign(__assign({}, styles.selectionListView.rowHeaderStyles), {
            paddingLeft: 10,
            fontWeight: 400
          }),
          rowHeaderContainerStyles: {
            borderBottom: last ? open ? "1px solid #e9e9e9" : "none" : "1px solid #e9e9e9",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow: "none",
            marginTop: 0,
            marginBottom: 0
          },
          onClickExpand: function () {
            var _a;
            return (_a = _this.state.pushHederRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
          },
          item: /*#__PURE__*/React.createElement(PnmacToolTip, {
            title: "Expand " + title
          }, /*#__PURE__*/React.createElement("div", {
            style: __assign({
              alignSelf: "center"
            }, textStyle.formTitleSection)
          }, title)),
          isExpand: ((_e = (_d = _this.state.pushHederRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
        });
      }
    })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 10,
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: textStyle.defaultTextTitle
    }, translations.eDis_WelcomeEDisbursements)), isEligible === null ? /*#__PURE__*/React.createElement(LinearBuffer, null) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacParagraph, {
      style: textStyle.defaultTextTitle
    }, translations.eDis_ReasonEDisbursementNotAvailable), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("ul", {
      style: __assign({
        marginLeft: 10,
        marginTop: 10
      }, textStyle.defaultTextDescription)
    }, /*#__PURE__*/React.createElement("li", null, translations.notAvailable))));
  };
  return Edisbursments;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(Edisbursments);